import * as React from 'react';
import { ConfigProvider, Select } from "antd";
import { ApplicationProgressDetails, QuestionDetails } from "../../../Models/applicationModels";
import { GlobalTableStyles } from "./globalTableStyles";
import { mapAnswersToOptions, processSelectOptions } from '../../../utils/answerUtils';
import { capitalizeFirstLetter, generateHierarchicalIndex } from '../../../utils/stringUtils';

interface IRecursiveRowProps {
    data: QuestionDetails[] | null,
    parentIndex: string,
    tableData: ApplicationProgressDetails
}

const emptyValue = [{
    questionTitle: "",
    questionOptions: [],
    answer: [],
    childQuestions: []
}]

const IsValueAvailable = (value: any) => {
    return (value && value !== null && value !== "")
}

const GetRowSpanValue = (rowValue: QuestionDetails[], finalValue: number) => {
    rowValue.map((question: QuestionDetails) => {
        finalValue = finalValue + 1
        if (question.childQuestions?.length > 0) {
            finalValue = GetRowSpanValue(question.childQuestions, finalValue)
        }
    })
    return finalValue
}

const ApplicationProgressRow = (props: IRecursiveRowProps) => {
    const { tableCell, answerListMenu } = GlobalTableStyles().classes
    const { data, parentIndex, tableData } = props
    const rowSpan = data ? GetRowSpanValue(data, 0) : 0
    const updatedData = data ?? emptyValue

    return (
        <>
            {
                updatedData?.map((rowValue: QuestionDetails, index: number) => {
                    const currentIndex = generateHierarchicalIndex(parentIndex, index + 1);
                    const mappedAnswer = mapAnswersToOptions(rowValue);
                    return (
                        <>
                            <tr>
                                {(index == 0 && parentIndex?.length === 0) &&
                                    <td className={tableCell} rowSpan={rowSpan}>
                                        {tableData.lastCompletedSection}
                                    </td>
                                }
                                <td className={tableCell}>
                                    {IsValueAvailable(rowValue.questionTitle) ? currentIndex : "-"}
                                </td>
                                <td className={tableCell}>
                                    {IsValueAvailable(rowValue.questionTitle) ? rowValue.questionTitle : "-"}
                                </td>
                                <td className={tableCell}>
                                    {rowValue.questionOptions?.length > 0
                                        ?
                                        <ConfigProvider renderEmpty={() => "No Options"} >
                                            <Select
                                                {...(mappedAnswer.length > 1 && { mode: "tags" })}
                                                removeIcon={false}
                                                className={answerListMenu}
                                                value={mappedAnswer}
                                                options={processSelectOptions(rowValue.questionOptions, capitalizeFirstLetter)}
                                            />
                                        </ConfigProvider>
                                        :
                                        IsValueAvailable(rowValue["answer"].toString()) ? rowValue["answer"].toString() : "-"
                                    }
                                </td>
                            </tr>
                            {rowValue?.childQuestions?.length > 0 &&
                                <ApplicationProgressRow tableData={tableData} data={rowValue?.childQuestions} parentIndex={currentIndex} />
                            }
                        </>
                    )
                })
            }
        </>
    )
}

export default ApplicationProgressRow